module.exports = __webpack_public_path__ + "static/elle-septembre-2014-couverture-729a087135f0f36540d91a8928808ded.jpg";